export const drawer = {
	selector: {
		own: 'data-drawer',
		handler: 'data-drawer-handler',
		sub: 'data-subdrawer',
		subHandler: 'data-subdrawer-handler',
		subClose: 'data-subdrawer-close',
	},
}
